<template>
    <div style="width: 100%; height: 100%;">
        <div id="stagerightMain" style="width: 100%; height: 100%;"></div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'StageRightChart',
    data() {
        return {
            myChart: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        if (this.myChart) {
            this.myChart.dispose();
        }
    },
    methods: {

        initChart() {
            var chartDom = document.getElementById('stagerightMain');
            if (!chartDom) return;
            this.myChart = echarts.init(chartDom);
            var option;

            option = {
                color: ['#67C23A', '#F56C6C', '#E6A23C', '#409EFF','#B300DE'],
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    top: '5%',
                    left: 'center'
                },
                series: [
                    {
                    name: '成绩分布',
                    type: 'pie',
                    radius: ['35%', '65%'],
                    center: ['50%', '60%'],
                    avoidLabelOverlap: false,
                    color: ['#67C23A', '#F56C6C', '#E6A23C', '#409EFF', '#B300DE'],
                    itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                    },
                    label: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontSize: 40,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: [
                        { value: 1048, name: '0-59' },
                        { value: 735, name: '60-69' },
                        { value: 580, name: '70-79' },
                        { value: 484, name: '80-89' },
                        { value: 300, name: '90-100' }
                    ]
                    }
                ]
                };

            option && this.myChart.setOption(option);
        },

        handleResize() {
            if (this.myChart) {
                this.myChart.resize();
            }
        }
        
    }
}
</script>
